
import { getSellEmployee, getAuthority } from '@/zsm-api-new/employee.js'
const state = {

}

const mutations = {

}
const actions = {
    /**
     * 获取默认销售人员
     * @returns 
     */
    getAuthority({ commit }) {
        return new Promise((resolve, reject) => {
            getAuthority().then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    /**
     * 通过id获取销售人员信息
     * @param {*} id 
     * @returns 
     */
    getSellEmployee({ commit }, id) {
        return new Promise((resolve, reject) => {
            getSellEmployee(id).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
